import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import completedImg from './img/completed.svg';
import waitingImg from './img/waiting.svg';
import * as styles from './OrderStatusModal.module.scss';

const OrderStatusModal = ({
    orderId, status, service, quantity, price,
}) => (
    <div className={styles.container}>
        <div className={styles.head}>
            <i className="fa fa-line-chart" aria-hidden="true" />
            <span className={styles.orderTracking}>Order tracking</span>
            <span className={styles.id}>
                {orderId}
            </span>
        </div>
        <div className={classNames(styles.status, { [styles.completed]: status.toUpperCase() === 'COMPLETED' })}>
            <img src={status === 'COMPLETED' ? completedImg : waitingImg} alt={status} />
            {status}
        </div>
        <ul className={styles.data}>
            <li>
                <span>
                    <FormattedMessage id="orderStatusModal.service" defaultMessage="Service" />
                </span>
                <span>
                    {service}
                </span>
            </li>
            <li>
                <span>
                    <FormattedMessage id="orderStatusModal.quantity" defaultMessage="Quantity" />
                </span>
                <span>
                    {quantity}
                </span>
            </li>
            <li>
                <span>
                    <FormattedMessage id="orderStatusModal.price" defaultMessage="Price" />
                </span>
                <span>
                    {`$${price}`}
                </span>
            </li>
        </ul>
    </div>
);

export default OrderStatusModal;
